import isObject from '../../utils/helpers/is-object';
import generateInterruptionEvent from '../helpers/generate-interruption-event';

const CALLBACK_INTERRUPTION_EVENT = 'ws:settings-callback';

const setInterruptionCallback = (setting) => {
  if (isObject(setting) || Array.isArray(setting)) {
    // eslint-disable-next-line no-use-before-define
    return replaceCallbackInterruptions(setting);
  }

  if (typeof setting === 'string' && setting.includes(CALLBACK_INTERRUPTION_EVENT)) {
    return (args) => generateInterruptionEvent(setting, args);
  }

  return setting;
};

const replaceCallbackInterruptions = (settings) => {
  if (isObject(settings)) {
    return Object.keys(settings).reduce((result, settingName) => {
      // eslint-disable-next-line no-param-reassign
      result[settingName] = setInterruptionCallback(settings[settingName]);

      return result;
    }, {});
  }

  if (Array.isArray(settings)) {
    return settings.map((setting) => setInterruptionCallback(setting));
  }

  return settings;
};

export default replaceCallbackInterruptions;
